<template>
  <div :class="listType == 'sidebar' ? 'mt-6' : 'ma-2'">
    <div class="overline text-center">{{ localTitle | titleize }}</div>
    <v-divider></v-divider>
    <v-list nav dense>
      <v-list-item-group>
        <v-list-item
          :to="`/${article.section}/${encodeURIComponent(article.slug)}`"
          v-for="article in articles"
          :key="article.id"
          color="primary"
          class="blue--text"
          rounded
        >
          <v-list-item-content>{{ article.name }}</v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";

export default {
  name: "ArticleList",
  props: {
    title: null,
    limit: null,
    sections: {
      type: Array,
      default: () => {
        return ["news", "blog"];
      },
      categories: null,
    },
    listType: { type: String, default: "sidebar" }, // "sidebar" or "page"
    // "page" will show more info, "sidebar" will be presented like a menu
  },
  data: function () {
    return {
      articles: null,
    };
  },
  methods: {
    getList() {
      ApiServices.articleList(this.paramString)
        .then((response) => {
          this.articles = response.data?.articles;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {});
    },
  },
  computed: {
    paramString: function () {
      let rtn = [];
      this.sections.forEach((section) => {
        rtn.push("section[]=" + section);
      });
      if (this.limit) rtn.push("limit=" + this.limit);
      return rtn.join("&");
    },
    localTitle: function () {
      if (this.title) return this.title;
      if (
        this.sections &&
        Array.isArray(this.sections) &&
        this.sections.length == 1
      )
        return this.sections[0];
      return "Articles";
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style scoped></style>
